/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Offline_QueuedInputs */

const en_us2_coach_offline_queued = /** @type {(inputs: Coach_Offline_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No connection. Your message goes out as soon as the internet is back.`)
};

const pt_br2_coach_offline_queued = /** @type {(inputs: Coach_Offline_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem conexão. Sua mensagem sai assim que a internet voltar.`)
};

const es_419_coach_offline_queued = /** @type {(inputs: Coach_Offline_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin conexión. Tu mensaje se envía en cuanto vuelva internet.`)
};

const pt_pt2_coach_offline_queued = /** @type {(inputs: Coach_Offline_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sem ligação. A tua mensagem segue assim que a internet voltar.`)
};

const fr_fr2_coach_offline_queued = /** @type {(inputs: Coach_Offline_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas de connexion. Ton message partira dès le retour d'internet.`)
};

const de_de2_coach_offline_queued = /** @type {(inputs: Coach_Offline_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Verbindung. Deine Nachricht geht raus, sobald das Internet wieder da ist.`)
};

const it_it2_coach_offline_queued = /** @type {(inputs: Coach_Offline_QueuedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna connessione. Il tuo messaggio parte appena torna internet.`)
};

/**
* | output |
* | --- |
* | "No connection. Your message goes out as soon as the internet is back." |
*
* @param {Coach_Offline_QueuedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_offline_queued = /** @type {((inputs?: Coach_Offline_QueuedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Offline_QueuedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_offline_queued(inputs)
	if (locale === "es-419") return es_419_coach_offline_queued(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_offline_queued(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_offline_queued(inputs)
	if (locale === "de-DE") return de_de2_coach_offline_queued(inputs)
	if (locale === "it-IT") return it_it2_coach_offline_queued(inputs)
	return en_us2_coach_offline_queued(inputs)
});
export { coach_offline_queued as "coach.offline_queued" }